module.exports = __webpack_public_path__ + "static/img/transaction.41174bea.png";